export default __webpack_public_path__ + "static/media/round-content-save-alt.71612ede.svg";